import { Zap, ShieldCheck, TrendingUp, Award } from "lucide-react";
import { site } from "@/lib/site";

const ICONS = [Zap, ShieldCheck, TrendingUp, Award];

export default function Diferenciais() {
  return (
    <section
      id="diferenciais"
      data-testid="diferenciais-section"
      className="relative bg-[#0e3b21] text-white py-20 sm:py-28 overflow-hidden grain"
    >
      <div
        aria-hidden
        className="absolute -top-24 -left-24 w-[380px] h-[380px] hex bg-[#c9a24c]/8"
      />
      <div
        aria-hidden
        className="absolute -bottom-32 -right-16 w-[420px] h-[420px] hex bg-[#c9a24c]/6"
      />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <div className="text-[#c9a24c] uppercase tracking-[0.25em] text-xs font-semibold">
            Por que Serequímica
          </div>
          <h2
            className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            Padrão profissional em <em className="text-[#c9a24c]">cada litro</em>{" "}
            que você aplica.
          </h2>
          <div className="gold-underline mt-5" />
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {site.pillars.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={p.title}
                data-testid={`pillar-${i}`}
                className="relative bg-[#0a2a17]/70 backdrop-blur-sm border border-white/8 rounded-2xl p-6 sm:p-7 hover:border-[#c9a24c]/50 transition-all duration-500 hover:-translate-y-1"
              >
                <div className="h-14 w-14 hex bg-[#c9a24c]/15 border-2 border-[#c9a24c]/40 flex items-center justify-center mb-5">
                  <Icon size={22} className="text-[#c9a24c]" strokeWidth={2.2} />
                </div>
                <h3
                  className="text-lg sm:text-xl font-bold text-white"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  {p.title}
                </h3>
                <p className="mt-3 text-sm text-white/70 leading-relaxed">
                  {p.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
